import { COLORS } from "shared/consts";
import styled from "styled-components";

export const Shell = styled.div`
    min-height: 100dvh;
    max-height: 100dvh;
    width: 100%;
    display: flex;
`;

export const Content = styled.div`
    width: 100%;
    max-width: 100vw;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    overflow: clip auto;
    background: ${COLORS.BG.PAGE};
    
    @media screen and (max-width: 992px) {
        padding-top: 56px;
    }
`;

export const TitleBar = styled.header`
    margin-bottom: 16px;
    padding-inline: 16px;
    display: flex;
    justify-content: space-between;
    
    h1 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: ${COLORS.FG.DEFAULT};
    }
`;

export const TitleRight = styled.div`
`

export const OutletWrapper = styled.div`
    padding-inline: 16px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`
